import WebFont from 'webfontloader';

const WebFontLoader = {
  install(Vue) {
    Vue.prototype.$webfontloader = WebFont;
  },
};

export default WebFontLoader;